import { createFileRoute } from "@tanstack/react-router"
import { NewRolePage } from "./-components/new-role-page"

export const Route = createFileRoute(
  "/_layout/settings/_panel/workspace/roles/create",
)({
  staticData: { breadcrumb: "New role" },
  component: CreateRolePage,
})

function CreateRolePage(): React.ReactElement {
  return <NewRolePage source={undefined} />
}
